import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Glossary, GlossaryData } from '../../../interfaces/masters/glossary';
import { GlossaryApi } from '../api/glossary.api';


@Injectable()
export class GlossaryService extends GlossaryData{

  constructor(private api: GlossaryApi) { 
    super();   
  }

  list(url: string): Observable<Glossary[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Glossary>{
      return this.api.getById(url); 
  }

  create(url: string, data:Glossary): Observable<Glossary> {
    return this.api.add(url,data);
  }

  update(url: string, data:Glossary): Observable<Glossary> {
    return this.api.update(url,data);
  }  

  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 
}
